import { CodeValue } from './code-value';

export type TranslationType = 'SIDE' | 'INLINE' | 'NONE' | 'ONLY';

export const TRANSLATION_TYPE_SIDE = 'SIDE';

export interface DataWithTranslation<T> {
	data: T;
	translations: CodeValue[];
}
